import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full mx-auto" }
const _hoisted_3 = {
  class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]",
  id: "offersNavigation"
}
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = {
  class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]",
  id: "offersForm"
}
const _hoisted_6 = {
  class: "my-[2.5%] text-2xl font-normal",
  id: "Lizenzkosten"
}
const _hoisted_7 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_8 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-[2%] mt-5 text-xl font-normal"
}
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = {
  class: "my-[2.5%] text-2xl font-normal",
  id: "Rabattierung"
}
const _hoisted_12 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_13 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_14 = {
  key: 0,
  class: "mb-[2%] mt-5 text-xl font-normal"
}
const _hoisted_15 = { class: "form-section" }
const _hoisted_16 = {
  class: "my-[2.5%] text-2xl font-normal",
  id: "Diverses"
}
const _hoisted_17 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_18 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_19 = {
  key: 0,
  class: "mb-[2%] mt-5 text-xl font-normal"
}
const _hoisted_20 = { class: "form-section" }
const _hoisted_21 = {
  class: "my-[2.5%] text-2xl font-normal",
  id: "Unterschriften"
}
const _hoisted_22 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_23 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_24 = {
  class: "my-[2.5%] text-2xl font-normal",
  id: "Sprache"
}
const _hoisted_25 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_26 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_27 = {
  class: "my-[2.5%] text-2xl font-normal",
  id: "PDF_bearbeiten"
}
const _hoisted_28 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_29 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}

import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import { ref } from 'vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import useOfferStore from '@/utils/useOfferStore'
    import { useRoute } from 'vue-router'
    import FormInput from '@/components/Offers/FormInput.vue'
    import { computed } from 'vue'
    import formFieldsJSON from '@/components/Offers/TheProposedOfferFormFields.json'
    import { Signature } from '@/model/types'
    import router from '@/router'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OffersCalculatePrice',
  setup(__props) {

    const { proposedOffer, generatePdf, signaturesList, fetchSignaturesList } = useOfferStore()
    const route = useRoute()

    async function fetchDataOnMounted() {
        await fetchSignaturesList()
        if (Object.keys(proposedOffer.value as object).length === 0) {
            router.push('/offers')
        }
    }

    fetchDataOnMounted()

    // default visibility of menus

    const formFields = ref(formFieldsJSON.formFields)
    const showLizenzkosten = ref(true)
    const showRabattierung = ref(true)
    const showDiverses = ref(true)
    const showUnterschriften = ref(true)
    const showLanguages = ref(true)
    const language = ref('DE')
    const showPDF = ref(true)

    // custom signatures

    let signed_2 = ref<Signature>({ id: 0, name: 'Unterschrift links' })
    let signed_1 = ref<Signature>({ id: 0, name: 'Unterschrift rechts' })

    // form fields refs

    let n_relevante_nutzer = ref(proposedOffer.value?.n_relevante_nutzer || '')
    let rabatt_bisher_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_bisher?.n_nutzer_rabattzone || ''
    )
    let rabatt_bisher_stufe = ref(proposedOffer.value?.rabatt_bisher?.stufe || '')
    let rabatt_bisher_betrag = ref(proposedOffer.value?.rabatt_bisher?.betrag || '')
    let rabatt_neu_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_neu?.n_nutzer_rabattzone || ''
    )
    let rabatt_neu_stufe = ref(proposedOffer.value?.rabatt_neu?.stufe || '')
    let rabatt_neu_betrag = ref(proposedOffer.value?.rabatt_neu?.betrag || '')
    let einrichtungspreis_total = ref(proposedOffer.value?.einrichtungspreis?.total || '')
    let kosten_urg_preis_pro_nutzer = ref(proposedOffer.value?.kosten_urg?.preis_pro_nutzer || '')
    let kosten_urg_total = ref(proposedOffer.value?.kosten_urg?.total || '')
    let sockelbetrag_preis_pro_nutzer = ref(
        proposedOffer.value?.sockelbetrag?.preis_pro_nutzer || ''
    )
    let sockelbetrag_total = ref(proposedOffer.value?.sockelbetrag?.total || '')
    let introduction = ref(proposedOffer.value?.introduction || '')
    let scope = ref(proposedOffer.value?.scope || '')
    let closure = ref(proposedOffer.value?.closure || '')

    // form field computed properties

    const computedProperty = (propPath: string) => {
        if (typeof propPath !== 'string') {
            return computed(() => '')
        }

        const pathParts = propPath.split('.')
        return computed({
            get: () => {
                let currentValue = proposedOffer.value
                for (const part of pathParts) {
                    if (currentValue === null || currentValue === undefined) {
                        return ''
                    }
                    currentValue = currentValue[part]
                }
                return currentValue
            },
            set: (newValue) => {
                let currentValue = proposedOffer.value
                for (let i = 0; i < pathParts.length - 1; i++) {
                    const part = pathParts[i]
                    if (currentValue && currentValue[part] === undefined) {
                        currentValue[part] = {}
                    }
                    if (currentValue !== null && currentValue !== undefined) {
                        currentValue = currentValue[part]
                    }
                }
                if (currentValue !== null && currentValue !== undefined) {
                    currentValue[pathParts[pathParts.length - 1]] = newValue
                }
            },
        })
    }

    n_relevante_nutzer = computedProperty('n_relevante_nutzer')
    rabatt_bisher_n_nutzer_rabattzone = computedProperty('rabatt_bisher.n_nutzer_rabattzone')
    rabatt_bisher_stufe = computedProperty('rabatt_bisher.stufe')
    rabatt_bisher_betrag = computedProperty('rabatt_bisher.betrag')
    rabatt_neu_n_nutzer_rabattzone = computedProperty('rabatt_neu.n_nutzer_rabattzone')
    rabatt_neu_stufe = computedProperty('rabatt_neu.stufe')
    rabatt_neu_betrag = computedProperty('rabatt_neu.betrag')
    einrichtungspreis_total = computedProperty('einrichtungspreis.total')
    kosten_urg_preis_pro_nutzer = computedProperty('kosten_urg.preis_pro_nutzer')
    kosten_urg_total = computedProperty('kosten_urg.total')
    sockelbetrag_preis_pro_nutzer = computedProperty('sockelbetrag.preis_pro_nutzer')
    sockelbetrag_total = computedProperty('sockelbetrag.total')
    introduction = computedProperty('introduction')
    scope = computedProperty('scope')
    closure = computedProperty('closure')

    // functions defined and used here

    const updateProposedOfferValue = (propPath: string, newValue: any) => {
        if (typeof propPath !== 'string') {
            return
        }

        const pathParts = propPath.split('.')
        let currentValue = proposedOffer.value
        for (let i = 0; i < pathParts.length - 1; i++) {
            const part = pathParts[i]
            if (!currentValue || !currentValue[part]) {
                if (currentValue && currentValue[part] === undefined) {
                    currentValue[part] = {}
                }
            }
            if (currentValue !== null && currentValue !== undefined) {
                currentValue = currentValue[part]
            }
        }
        if (currentValue !== null && currentValue !== undefined) {
            currentValue[pathParts[pathParts.length - 1]] = newValue
        }
    }

    // TODO: There must be a simpler / more mainstream way

    const transformPayloadForPdf = (offer: any): any => {
        return {
            EDU_BASIC: {
                preis_pro_nutzer: offer.EDU_BASIC?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.EDU_BASIC?.preis_pro_vzae || '0',
                total: offer.EDU_BASIC?.total ?? 0,
            },
            EDU_SWISS: {
                preis_pro_nutzer: offer.EDU_SWISS?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.EDU_SWISS?.preis_pro_vzae || '0',
                total: offer.EDU_SWISS?.total ?? 0,
            },
            argumente: offer.argumente || [],
            einrichtungspreis: {
                total: offer.einrichtungspreis?.total ? Number(offer.einrichtungspreis.total) : 0,
            },
            error_code: offer.error_code !== undefined ? offer.error_code : null,
            error_details: offer.error_details || null,
            git_revision: offer.git_revision !== undefined ? Number(offer.git_revision) : 0,
            kosten_urg: {
                preis_pro_nutzer: offer.kosten_urg?.preis_pro_nutzer || '0',
                total: offer.kosten_urg?.total ? Number(offer.kosten_urg.total) : 0,
            },
            n_fte: offer.n_fte !== undefined ? Number(offer.n_fte) : 0,
            n_lehrende_dozierende:
                offer.n_lehrende_dozierende !== undefined ? Number(offer.n_lehrende_dozierende) : 0,
            n_lernende_studierende:
                offer.n_lernende_studierende !== undefined
                    ? Number(offer.n_lernende_studierende)
                    : 0,
            n_nutzer_korrektur:
                offer.n_nutzer_korrektur !== undefined ? Number(offer.n_nutzer_korrektur) : 0,
            n_relevante_nutzer:
                offer.n_relevante_nutzer !== undefined ? Number(offer.n_relevante_nutzer) : 0,
            n_vollzeitaequivalente:
                offer.n_vollzeitaequivalente !== undefined
                    ? Number(offer.n_vollzeitaequivalente)
                    : 0,
            preisfunktion: offer.calculator_function || '',
            rabatt_bisher: {
                betrag: offer.rabatt_bisher?.betrag || '',
                n_nutzer_rabattzone: offer.rabatt_bisher?.n_nutzer_rabattzone || '',
                stufe: offer.rabatt_bisher?.stufe || '',
            },
            rabatt_neu: {
                betrag: offer.rabatt_neu?.betrag || '',
                n_nutzer_rabattzone: offer.rabatt_neu?.n_nutzer_rabattzone || '',
                stufe: offer.rabatt_neu?.stufe || '',
            },
            regulaerer_preis: {
                preis_pro_nutzer: offer.regulaerer_preis?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.regulaerer_preis?.preis_pro_vzae || '0',
                total:
                    offer.regulaerer_preis?.total !== undefined
                        ? Number(offer.regulaerer_preis.total)
                        : 0,
            },
            richtpreis: {
                preis_pro_nutzer: offer.richtpreis?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.richtpreis?.preis_pro_vzae || '0',
                total: offer.richtpreis?.total !== undefined ? Number(offer.richtpreis.total) : 0,
            },
            schultyp: offer.school_type || '',
            sockelbetrag: {
                preis_pro_nutzer: offer.sockelbetrag?.preis_pro_nutzer || '0',
                total:
                    offer.sockelbetrag?.total !== undefined ? Number(offer.sockelbetrag.total) : 0,
            },
            status: offer.status || '',
            zeitstempel: offer.calculator_timestamp || new Date().toISOString(),
            contact_id: offer.contact_id !== undefined ? Number(offer.contact_id) : 0,
            offer_id: offer.offer_id !== undefined ? Number(offer.offer_id) : 0,
            introduction: offer.introduction || '',
            scope: offer.scope || '',
            closure: offer.closure || '',
            responsible_1: offer.responsible_1 !== undefined ? Number(offer.responsible_1) : 0,
            responsible_2: offer.responsible_2 !== undefined ? Number(offer.responsible_2) : 0,
            language: offer.language || 'DE',
        }
    }

    function submit() {
        proposedOffer.value = {
            ...proposedOffer.value,
            n_relevante_nutzer: n_relevante_nutzer.value,
            rabatt_bisher: {
                n_nutzer_rabattzone: rabatt_bisher_n_nutzer_rabattzone.value,
                stufe: rabatt_bisher_stufe.value,
                betrag: rabatt_bisher_betrag.value,
            },
            rabatt_neu: {
                n_nutzer_rabattzone: rabatt_neu_n_nutzer_rabattzone.value,
                stufe: rabatt_neu_stufe.value,
                betrag: rabatt_neu_betrag.value,
            },
            einrichtungspreis: {
                total: einrichtungspreis_total.value,
            },
            kosten_urg: {
                preis_pro_nutzer: kosten_urg_preis_pro_nutzer.value,
                total: kosten_urg_total.value,
            },
            sockelbetrag: {
                preis_pro_nutzer: sockelbetrag_preis_pro_nutzer.value,
                total: sockelbetrag_total.value,
            },
            introduction: introduction.value,
            scope: scope.value,
            closure: closure.value,
        }

        // Set responsible persons and language as you already do
        proposedOffer.value.responsible_2 = signed_2.value.id ? signed_2.value.id : 5169
        proposedOffer.value.responsible_1 = signed_1.value.id ? signed_1.value.id : 2
        proposedOffer.value.language = language.value

        // Transform the payload to exactly match what the PDF endpoint expects
        const pdfPayload = transformPayloadForPdf(proposedOffer.value)

        generatePdf({
            proposedOffer: { data: pdfPayload },
            offerId: proposedOffer.value.offer_id,
            contactId: Number(route.params.id),
        })
    }

    //breadcrumbs

    const breadcrumbs = [
        {
            title: 'Offerten',
            disabled: false,
            href: '/offers',
        },
        {
            title: 'Kontakt auswählen',
            disabled: false,
            href: '/offers/selectcontacts',
        },
        {
            title: 'Parameter eingeben',
            disabled: true,
            href: '/offers/createoffer/',
        },
        {
            title: 'Berechnete Offerte',
            disabled: true,
            href: '/offers/calculateprice/',
        },
    ]

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(offerNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs }),
      _createElementVNode("div", _hoisted_5, [
        _cache[29] || (_cache[29] = _createElementVNode("h2", { class: "text-left text-2xl font-medium mb-[3%]" }, [
          _createElementVNode("strong", null, "Berechneter Vorschlag")
        ], -1)),
        _createVNode(_component_v_form, {
          onSubmit: _withModifiers(submit, ["prevent"]),
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_6, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showLizenzkosten.value = !showLizenzkosten.value))
              }, [
                _cache[18] || (_cache[18] = _createTextVNode("Lizenzkosten ", -1)),
                (showLizenzkosten.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : (_openBlock(), _createElementBlock("i", _hoisted_8))
              ])
            ]),
            (showLizenzkosten.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 0,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(FormInput, {
                      modelValue: _unref(n_relevante_nutzer),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(n_relevante_nutzer) ? (n_relevante_nutzer).value = $event : n_relevante_nutzer = $event)),
                      label: "Anzahl relevante Nutzer",
                      onChange: _cache[2] || (_cache[2] = (e) => (_isRef(n_relevante_nutzer) //@ts-ignore
 ? n_relevante_nutzer.value = e.target.value : n_relevante_nutzer = e.target.value))
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value[0], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        ('title' in section)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _toDisplayString(section.title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                            return (_openBlock(), _createBlock(FormInput, {
                              key: field.label,
                              label: field.label,
                              modelValue: computedProperty(field.model).value as string,
                              "onUpdate:modelValue": ($event: any) => ((computedProperty(field.model).value as string) = $event),
                              disabled: field?.disabled || false,
                              onChange: 
                                    (event) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                          }), 128))
                        ])
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_11, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showRabattierung.value = !showRabattierung.value))
              }, [
                _cache[19] || (_cache[19] = _createTextVNode("Rabattierung ", -1)),
                (showRabattierung.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                  : (_openBlock(), _createElementBlock("i", _hoisted_13))
              ])
            ]),
            (showRabattierung.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 1,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value[1], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        ('title' in section)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_14, _toDisplayString(section.title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                            return (_openBlock(), _createBlock(FormInput, {
                              key: field.label,
                              label: field.label,
                              modelValue: computedProperty(field.model).value as string,
                              "onUpdate:modelValue": ($event: any) => ((computedProperty(field.model).value as string) = $event),
                              disabled: field.disabled || false,
                              onChange: 
                                    (event) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                          }), 128))
                        ])
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[25] || (_cache[25] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_16, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showDiverses.value = !showDiverses.value))
              }, [
                _cache[20] || (_cache[20] = _createTextVNode("Diverses ", -1)),
                (showDiverses.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                  : (_openBlock(), _createElementBlock("i", _hoisted_18))
              ])
            ]),
            (showDiverses.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 2,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value[2], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        ('title' in section)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_19, _toDisplayString(section.title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                            return (_openBlock(), _createBlock(FormInput, {
                              key: field.label,
                              label: field.label,
                              modelValue: computedProperty(field.model).value as string,
                              "onUpdate:modelValue": ($event: any) => ((computedProperty(field.model).value as string) = $event),
                              disabled: field.disabled,
                              onChange: 
                                    (event) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                          }), 128))
                        ])
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_21, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showUnterschriften.value = !showUnterschriften.value))
              }, [
                _cache[21] || (_cache[21] = _createTextVNode("Unterschriften ", -1)),
                (showUnterschriften.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                  : (_openBlock(), _createElementBlock("i", _hoisted_23))
              ])
            ]),
            (showUnterschriften.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 3,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      style: {"width":"50%","display":"inline-block"},
                      class: "p-[5px]",
                      modelValue: _unref(signed_2),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(signed_2) ? (signed_2).value = $event : signed_2 = $event)),
                      items: _unref(signaturesList),
                      "item-title": "name",
                      "item-value": "id",
                      "return-object": "",
                      "single-line": ""
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_select, {
                      style: {"width":"50%","display":"inline-block"},
                      class: "p-[5px]",
                      modelValue: _unref(signed_1),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(signed_1) ? (signed_1).value = $event : signed_1 = $event)),
                      items: _unref(signaturesList),
                      "item-title": "name",
                      "item-value": "id",
                      "return-object": "",
                      "single-line": ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[27] || (_cache[27] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_24, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (showLanguages.value = !showLanguages.value))
              }, [
                _cache[22] || (_cache[22] = _createTextVNode("Sprache ", -1)),
                (showLanguages.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                  : (_openBlock(), _createElementBlock("i", _hoisted_26))
              ])
            ]),
            (showLanguages.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 4,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                      modelValue: language.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((language).value = $event)),
                      inline: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Deutsch",
                          value: "DE"
                        }),
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Französisch",
                          value: "FR"
                        }),
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Italienisch",
                          value: "IT"
                        }),
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Englisch",
                          value: "EN"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[28] || (_cache[28] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_27, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (showPDF.value = !showPDF.value))
              }, [
                _cache[23] || (_cache[23] = _createTextVNode("PDF bearbeiten ", -1)),
                (showPDF.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                  : (_openBlock(), _createElementBlock("i", _hoisted_29))
              ])
            ]),
            (showPDF.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 5,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      style: {"width":"100%","display":"inline-block"},
                      class: "p-[5px]",
                      label: "Individuelle Einleitung",
                      modelValue: _unref(introduction),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(introduction) ? (introduction).value = $event : introduction = $event)),
                      onChange: _cache[12] || (_cache[12] = (e) => (_isRef(introduction) //@ts-ignore
 ? introduction.value = e.target.value : introduction = e.target.value))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      style: {"width":"100%","display":"inline-block"},
                      class: "p-[5px]",
                      label: "Individueller Leistungsumfang",
                      modelValue: _unref(scope),
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(scope) ? (scope).value = $event : scope = $event)),
                      onChange: _cache[14] || (_cache[14] = (e) => (_isRef(scope) //@ts-ignore
 ? scope.value = e.target.value : scope = e.target.value))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      style: {"width":"100%","display":"inline-block"},
                      class: "p-[5px]",
                      label: "Individueller Schluss",
                      modelValue: _unref(closure),
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(closure) ? (closure).value = $event : closure = $event)),
                      onChange: _cache[16] || (_cache[16] = (e) => (_isRef(closure) //@ts-ignore
 ? closure.value = e.target.value : closure = e.target.value))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(FullButton, {
              id: "generatePdfButton",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (submit())),
              link: "",
              title: "PDF generieren >",
              width: "100",
              colour: "red"
            })
          ]),
          _: 1
        }, 512),
        _cache[30] || (_cache[30] = _createElementVNode("canvas", { class: "w-100 h-[30px]" }, null, -1))
      ])
    ])
  ], 64))
}
}

})